module.exports = __webpack_public_path__ + "img/ic-prevalence.7e99531b.svg";